"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactTether = _interopRequireDefault(require("react-tether"));

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Component to trigger an overlay rendered outside the current react DOM root.
 */
var Trigger = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Trigger, _React$Component);

  var _super = _createSuper(Trigger);

  function Trigger(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Trigger);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_tetherRef", void 0);
    _this._handleClick = _this._handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this._setTetherRef = _this._setTetherRef.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Trigger, [{
    key: "_setTetherRef",
    value: function _setTetherRef(el) {
      this._tetherRef = el;
    } // eslint-disable-next-line complexity

  }, {
    key: "_handleClick",
    value: function _handleClick(event) {
      if (this._tetherRef && this.props.open) {
        var _event$composedPath, _this$props$onOutside, _this$props, _this$props$onOutside2, _this$props2;

        var tetheredContainer = this._tetherRef.getTetherInstance().element;

        var path = event.path || ((_event$composedPath = event.composedPath) === null || _event$composedPath === void 0 ? void 0 : _event$composedPath.call(event)) || (0, _utils.getEventPath)(event);
        var tetherInPath = path.find(function (el) {
          var _el$classList, _el$classList$toStrin, _el$classList$toStrin2;

          return (_el$classList = el.classList) === null || _el$classList === void 0 ? void 0 : (_el$classList$toStrin = _el$classList.toString()) === null || _el$classList$toStrin === void 0 ? void 0 : (_el$classList$toStrin2 = _el$classList$toStrin.split(' ')) === null || _el$classList$toStrin2 === void 0 ? void 0 : _el$classList$toStrin2.find(function (c) {
            return /tetherElement.*/.test(c);
          });
        }); //check if the clicked element is the tether container
        //or another tether element (for when nesting components which both use tether)

        if (!tetherInPath) (_this$props$onOutside = (_this$props = this.props).onOutsideClick) === null || _this$props$onOutside === void 0 ? void 0 : _this$props$onOutside.call(_this$props, event);
        if (tetheredContainer !== tetherInPath && (tetherInPath === null || tetherInPath === void 0 ? void 0 : tetherInPath.parentNode)) (_this$props$onOutside2 = (_this$props2 = this.props).onOutsideClick) === null || _this$props$onOutside2 === void 0 ? void 0 : _this$props$onOutside2.call(_this$props2, event);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this._attachEvents();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._detachEvents();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.open) {
        this._attachEvents();
      } else {
        this._detachEvents();
      }
    }
  }, {
    key: "_attachEvents",
    value: function _attachEvents() {
      setTimeout(window.addEventListener.bind(window), 0, 'click', this._handleClick);
    }
  }, {
    key: "_detachEvents",
    value: function _detachEvents() {
      setTimeout(window.removeEventListener.bind(window), 0, 'click', this._handleClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          face = _this$props3.face,
          open = _this$props3.open,
          children = _this$props3.children,
          positionHorizontal = _this$props3.positionHorizontal,
          positionVertical = _this$props3.positionVertical,
          relativeOffset = _this$props3.relativeOffset,
          relativeShift = _this$props3.relativeShift,
          props = (0, _objectWithoutProperties2["default"])(_this$props3, ["face", "open", "children", "positionHorizontal", "positionVertical", "relativeOffset", "relativeShift"]);
      var calculatedAttachments = (0, _utils.calculateAttachments)(positionHorizontal, positionVertical);
      var calculatedOffset = (0, _utils.calculateOffsets)(relativeOffset, relativeShift, positionHorizontal, positionVertical);
      return /*#__PURE__*/React.createElement(_reactTether["default"], (0, _extends2["default"])({}, props, calculatedAttachments, calculatedOffset, {
        ref: this._setTetherRef
      }), React.Children.only(face), open && React.Children.only(children));
    }
  }]);
  return Trigger;
}(React.Component);

exports["default"] = Trigger;
//# sourceMappingURL=index.js.map